<template>
  <div id="page">
    <NavBar />
    <main>
      <div class="container margin_60_35">
        <div class="row">
          <div class="col-md-3 col-lg-3">
            <div class="fixed_help_aside">
              <aside id="faq_cat">
                <div
                  id="faq_box"
                  class="box_style_cat"
                >
                  <ul id="cat_nav">
                    <li v-for="(title, id) in $t('lang.help.faq') ">
                      <a
                        v-scroll-to="{el: '#'+id, offset: -140}"
                        :href="'#'+id"
                        class="active"
                        @click="openFaq(id)"
                      ><i :class="'ti-'+icons[id]" />{{ title }}</a>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>

          <div
            id="faq"
            class="col-sm-12 col-md-9 col-lg-9"
          >
            <div
              v-for="(title, id) in $t('lang.help.faq') "
              :id="id"
              :key="id"
              role="tablist"
              class="accordion_2"
            >
              <div class="card">
                <div
                  class="card-header"
                  role="tab"
                >
                  <h4 class="mb-0">
                    <a
                      :id="'title_'+id"
                      class="collapsed"
                      data-toggle="collapse"
                      :href="'#collapse_'+id"
                      aria-expanded="true"
                    >
                      <i :class="'ti-'+icons[id]+' mr-3'" />
                      <i class="indicator ti-plus" />{{ title }}
                    </a>
                  </h4>
                </div>
                <div
                  :id="'collapse_'+id"
                  class="collapse"
                  role="tabpanel"
                  :data-parent="'#'+id"
                >
                  <div class="card-body">
                    <p v-html="$t('lang.help.'+id+'_text')" />

                    <div
                      v-if="id === 'how'"
                      class="youtube-player w-100 text-center"
                    >
                      <iframe
                        width="380"
                        height="220"
                        :src="videoUrl"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /accordion -->

            <div class="text-right mt-4">
              <a
                target="_blank"
                href="https://storyset.com/"
                style="text-align:right; font-size: 0.65rem"
              >Illustrations by Storyset</a>
            </div>
          </div>

          <!-- /col -->
        </div>
        <!-- /row -->
      </div>
      <!--/container-->
    </main>

    <FooterComponent />
  </div>
</template>

<script>
import NavBar from '../components/NavBar/NavBar';
import FooterComponent from '../components/FooterComponent';

export default {
  name: 'HelpSection',

  components: {
    NavBar,
    FooterComponent,
  },

  data() {
    return {
      icons: {
        how: 'help',
        when: 'alarm-clock',
        security: 'lock',
        search: 'location-pin',
        booking: 'agenda',
        after_booking: 'check-box',
        payment: 'money',
        review: 'heart',
        cancellation: 'trash',
        claim: 'alert',
        discount: 'gift',
        bags: 'bag',
        other: 'info',
      },
      videoUrl: 'https://www.youtube.com/embed/8EKkqxfpqNU?rel=0&modestbranding=1&autoplay=0',
    };
  },

  mounted() {
    document.getElementById('collapse_how').className += ' show';
    document.getElementById('title_how').className = 'collapse';
  },

  methods: {
    openFaq(id) {
      document.getElementById(`collapse_${id}`).className += ' show';
      document.getElementById(`title_${id}`).className = 'collapse';
    },
  },
};
</script>

<style scoped>
.youtube-player iframe {
  border-radius: 8px; /* opcional: estilo de mini reproductor */
  margin: 0 auto;
}
</style>
